import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import 'src/App.css';


//	Main Template Parts
import Header from 'src/components/parts/Header';
import Footer from 'src/components/parts/Footer';

//	Pages
import Home from 'src/components/pages/Home';
import Tag from 'src/components/pages/Tag';
import Contact from 'src/components/pages/Contact';
import Search from 'src/components/pages/Search';
import Chatroom from 'src/components/pages/Chatroom';
import Error from 'src/components/pages/Error';

class App extends Component {
  render() { 
    return (
		<div className="App">
			<Header />
			<div className="App-page">
				<Switch>
					<Route path="/" component={Home} exact />
					<Route path="/tag/" component={Tag} />
					<Route path="/contact/" component={Contact} />
					<Route path="/search/" component={Search} />
					<Route path="/chat/" component={Chatroom} />
					<Route component={Error} />
				</Switch>
			</div>
			<Footer />
		</div>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js